import { useEffect, useState } from 'react';
import {
  UPLOAD_REQUESTS_CHANGED_EVENT,
  getPendingUploadRequestsCountApi,
} from '../../../api/uploadRequestApi';
import Label from '../../../components/Label';

// ----------------------------------------------------------------------

const REFRESH_MS = 60000;

// The number of pending upload requests, next to the menu item
export default function UploadRequestsBadge() {
  const [count, setCount] = useState(0);

  useEffect(() => {
    let alive = true;
    const load = () =>
      getPendingUploadRequestsCountApi()
        .then((n) => alive && setCount(n))
        .catch(() => undefined);
    load();
    const timer = setInterval(load, REFRESH_MS);
    window.addEventListener(UPLOAD_REQUESTS_CHANGED_EVENT, load);
    return () => {
      alive = false;
      clearInterval(timer);
      window.removeEventListener(UPLOAD_REQUESTS_CHANGED_EVENT, load);
    };
  }, []);

  if (!count) return null;
  return (
    <Label color="error" variant="filled">
      {count > 99 ? '99+' : count}
    </Label>
  );
}
